var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LabeledSelect',_vm._b({attrs:{"value":_vm.value,"option-key":"metadata.name","option-label":"metadata.name","create-option":_vm.createNewStorageClassName,"localized-label":false,"options":_vm.options,"push-tags":true,"taggable":true},on:{"input":_vm.updateName}},'LabeledSelect',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }